
// MixinsUtilities: used by DcmConfigService (validateSsin)
import mixins from "@/@core/mixins";
import MixinsUtilities from "@/@modules/fseg/services/MixinsUtilities";
import { DcmConfigService } from "@/@modules/fseg/services/DcmConfigService";
import FsegLayout from "@/@modules/fseg/components/Layout.vue";
import SignatureList from "@/@modules/fseg/components/SignatureList.vue";

export default mixins(MixinsUtilities).extend({
  components: {
    FsegLayout,
    SignatureList,
  },
  data() {
    return {
      config: DcmConfigService.getAgentConfigForSignatureList(this),
    };
  },
});
